import { h, render, Component } from 'preact';
import CommonBlock from './commonBlock';

export default class ComplexInline extends CommonBlock {
  constructor(props) {
    super(props);

    this.state = {
      content: '',
    };
  }

  render() {
    return (
      <div
        id="wioContent"
        dangerouslySetInnerHTML={{ __html: this.state.content }}
      />
    );
  }
}
